import { urlBase } from './urls';
import { encrypt, decrypt } from '../functions/mobile';

const feathers = require('@feathersjs/feathers');
const socketio = require('@feathersjs/socketio-client');
const io = require('socket.io-client');
const auth = require('@feathersjs/authentication-client');

const socket = io(`${urlBase}`, {
  transports: ['websocket'],
  forceNew: true
});
const client = feathers();

client.configure(socketio(socket, { timeout: 60000 }));

client.configure(auth({
  storageKey: 'auth'
}))

function beforeEncrypt(context) {
  if (context.data) {
    const plaintext = typeof context.data === 'string'
      ? context.data
      : JSON.stringify(context.data);
    const encrypted = encrypt(plaintext);
    context.data = { encrypted: encrypted };
  }
  return context;
}

function afterDecrypt(context) {
  console.log(context)
  if (context.result && context.result.encrypted) {
    try {
      
      const decrypted = decrypt(context.result.encrypted);

      if (decrypted !== undefined) {
        context.result = JSON.parse(decrypted);
      }
    } catch (error) {
      console.log(error);

    }
  }

  return context;
}

client.hooks({
  before: { all: [beforeEncrypt] },
  after: { all: [afterDecrypt] },
})
// Authenticate with the local email/password strategy 
/* client.authenticate({
  strategy: 'local',
  email: 'juankurdiales@hotmail.com',
  password: 'jnk'
}).then(() => {
  // Logged in
}).catch(e => {
  // Show login page (potentially with `e.message`)
  console.error('Authentication error', e);
}); */


//const messageService = client.service('transfers');

// messageService.on('created', message => console.log('Created a message', message));




export default client;
/* import io from 'socket.io-client';
import feathers from '@feathersjs/client';
import rx from 'feathers-reactive/dist/feathers-reactive';

const socket = io('http://localhost:3023');
const client = feathers()
  .configure(feathers.socketio(socket))
  .configure(rx({
    idField: 'id'
  }));

export default client;*/ 